import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface QuickReply {
  id: string;
  text: string;
  category: string;
  createdBy?: string;
  createdAt: string;
}

const CATEGORIES = [
  'saudacao',
  'aguarde',
  'prazo',
  'documentos',
  'encaminhamento',
  'informacao',
  'conclusao',
  'encerramento',
  'outro',
] as const;

export const CATEGORY_LABELS: Record<string, string> = {
  saudacao: 'Saudacao',
  aguarde: 'Aguarde',
  prazo: 'Prazo',
  documentos: 'Documentos',
  encaminhamento: 'Encaminhamento',
  informacao: 'Informacao',
  conclusao: 'Conclusao',
  encerramento: 'Encerramento',
  outro: 'Outro',
};

export { CATEGORIES };

interface QuickReplyState {
  replies: QuickReply[];
  addReply: (text: string, category: string, createdBy?: string) => void;
  updateReply: (id: string, text: string, category: string) => void;
  deleteReply: (id: string) => void;
}

export const useQuickReplyStore = create<QuickReplyState>()(
  persist(
    set => ({
      replies: [],

      addReply: (text, category, createdBy) =>
        set(state => ({
          replies: [
            ...state.replies,
            {
              id: `qr-${Date.now()}`,
              text,
              category,
              createdBy,
              createdAt: new Date().toISOString(),
            },
          ],
        })),

      updateReply: (id, text, category) =>
        set(state => ({
          replies: state.replies.map(r => (r.id === id ? { ...r, text, category } : r)),
        })),

      deleteReply: id =>
        set(state => ({
          replies: state.replies.filter(r => r.id !== id),
        })),
    }),
    {
      name: 'wa-quick-replies',
    },
  ),
);
